export interface CsvImportProjectError {
  errorFields: ProjectErrorField[];
  name?: string;
  clientName?: string;
}

export interface CsvImportProjectsErrorResponse {
  importErrors: CsvImportProjectError[];
}

export enum ProjectErrorField {
  NAME = 'NAME',
  CLIENT = 'CLIENT',
}
